import { useEffect, useState } from 'react';

/** Shared launch deadline: 47 min 12 s from page load, so every timer on the page stays in sync. */
const DEADLINE = Date.now() + (47 * 60 + 12) * 1000;

export type TimeLeft = {
  h: number;
  m: number;
  s: number;
};

function getTimeLeft(): TimeLeft {
  const seconds = Math.max(0, Math.floor((DEADLINE - Date.now()) / 1000));
  return {
    h: Math.floor(seconds / 3600),
    m: Math.floor(seconds % 3600 / 60),
    s: seconds % 60
  };
}

export function useCountdown(): TimeLeft {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(getTimeLeft);
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return timeLeft;
}

export function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
